import type { BoxState } from './states';

const STATE_WORDS: Record<BoxState, string> = {
  labelled: 'not received yet',
  in_stock: 'in stock',
  picked: 'picked for an order',
  shipped: 'shipped',
  in_transit: 'in transit',
  written_off: 'written off',
  voided: 'voided',
};

/**
 * Why a box in this state can't be written off, or null when it can. The API's 409 and the
 * disabled Write off button give this one sentence, so they can't disagree.
 */
export function writeOffStateProblem(state: BoxState): string | null {
  return state === 'in_stock' || state === 'in_transit' ? null : `Only boxes in stock or in transit can be written off. This one is ${STATE_WORDS[state]}.`;
}

/**
 * A lead acts only on boxes at their own sites; an admin (`siteIds` null) acts anywhere. For a
 * write-off that is the box's recorded site, and only while the box is in stock: in transit it
 * belongs to no site yet. Box lookup hides Write off where this is true, and the API refuses it.
 */
export function writeOffSiteBlocked(box: { state: BoxState; siteId: string | null }, siteIds: string[] | null): boolean {
  return box.state === 'in_stock' && box.siteId !== null && siteIds !== null && !siteIds.includes(box.siteId);
}

/** The line Box lookup shows in place of Write off, and the API's 403 for it. */
export function writeOffOtherSiteMessage(siteName: string): string {
  return `This box is recorded at ${siteName}. Only someone at ${siteName}, or an admin, can write it off.`;
}

/** Found / return puts a box at a site; the API's 403 when that site is not one of the lead's. */
export function foundOtherSiteMessage(siteName: string): string {
  return `Only someone at ${siteName}, or an admin, can put a box at ${siteName}.`;
}
